import {
  applyMiddleware, combineReducers, compose, createStore
} from 'redux'
import loggerMiddleware from 'redux-logger'
import createSagaMiddleware from 'redux-saga'

import rootSaga from './rootSaga'

import user from './reducers/user'
import auth from './reducers/auth'
import beneficiary from './reducers/beneficiary'
import company from './reducers/company'
import programme from './reducers/programme'
import collection from './reducers/collection'
import overview from './reducers/overview'
import equipment from './reducers/equipment'
import loan from './reducers/loan'
import notification from './reducers/notification'
import exam from './reducers/exam'

require('core-js/features/object/assign')

export const rootReducer = combineReducers({
  user,
  auth,
  beneficiary,
  company,
  programme,
  collection,
  overview,
  equipment,
  loan,
  notification,
  exam,
})

const sagaMiddleware = createSagaMiddleware()

const dev = process.env.NODE_ENV === 'development'

// eslint-disable-next-line import/no-mutable-exports
let store
if (dev) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware, loggerMiddleware))
  )
} else {
  store = createStore(rootReducer, applyMiddleware(sagaMiddleware))
}

sagaMiddleware.run(rootSaga)

export default store
